var cilSignalCellular0 = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M16,456.78V496H496V16H456.78ZM464,464H54.035L464,54.034Z' class='ci-primary'/>"];

export { cilSignalCellular0 };
//# sourceMappingURL=cil-signal-cellular-0.js.map
